import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

interface Body {
  kitchenScreenId: string;
  orderId: number;
  cartUsageItemId: number;
}

const useCartItemKitchenPatch = (customBranch?: number) => {
  const { t } = useTranslation();
  const id = useBranchId();
  const branch = customBranch || id;
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.create"));
    },
    mutationFn: ({
      orderId,
      cartUsageItemId,
      kitchenScreenId,
      ...body
    }: Body) =>
      patch(
        `/internal/secure/pos/v1/cart/items/kitchen/screen/id/${branch}/${orderId}/${cartUsageItemId}/${kitchenScreenId}`,
        body
      ),
  });
  return mutation;
};

export default useCartItemKitchenPatch;
